/**
 * 持久化裝置識別碼，跨登入/重新整理存活，供後端記錄裝置使用情況與未來多裝置訊息同步參考。
 * 存於 appIndexedDB（非 localStorage），與 mygenie_token 等鍵同一套儲存機制。
 */
import * as appStorage from './appIndexedDB';

export const DEVICE_ID_STORAGE_KEY = 'mygenie_device_id';

/**
 * 確保裝置識別碼存在：若尚未產生則建立一組並寫入儲存。
 * 請在 React root.render 之前呼叫（比照 appIndexedDB 的 ready()），
 * 確保後續同步讀取（getDeviceId）在任何 API 呼叫前已就緒。
 *
 * @returns {Promise<string|null>} 裝置識別碼；環境不支援 crypto.randomUUID 時回傳 null
 */
export async function ensureDeviceId() {
  const existing = await appStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (existing) {
    return existing;
  }
  if (typeof crypto === 'undefined' || typeof crypto.randomUUID !== 'function') {
    return null;
  }
  const id = crypto.randomUUID();
  await appStorage.setItem(DEVICE_ID_STORAGE_KEY, id);
  return id;
}

/** 同步讀取目前的裝置識別碼（需先呼叫過 ensureDeviceId）；尚未就緒時回傳 null */
export function getDeviceId() {
  return appStorage.getItemSync(DEVICE_ID_STORAGE_KEY);
}
